module.exports = __webpack_public_path__ + "img/footprint-bg.03855fa1.png";